import React from 'react';
import Sidebar from '../Sidebar';

const Credit = () => {
  return (
    <div className='w-full flex gap-4'>
      <Sidebar />
      Get ALL accounts credits
    </div>
  );
};

export default Credit;
